import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { LandingPage } from './pages/LandingPage';
import { ContextEngineeringPage } from './pages/ContextEngineeringPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { ArchitecturePage } from './pages/ArchitecturePage';
import { AboutPage } from './pages/AboutPage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { BlogPage } from './pages/BlogPage';
import { BlogArticleDetail } from './pages/BlogArticleDetail';
import { LoginPage } from './pages/LoginPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<LandingPage data-id="element-4" />} data-id="element-3" />
        <Route path="/context-engineering" element={<ContextEngineeringPage data-id="element-6" />} data-id="element-5" />
        <Route path="/how-it-works" element={<HowItWorksPage data-id="element-8" />} data-id="element-7" />
        <Route path="/the-instruction-layer" element={<ArchitecturePage data-id="element-10" />} data-id="element-9" />
        <Route path="/about" element={<AboutPage data-id="element-12" />} data-id="element-11" />
        <Route path="/pricing" element={<PricingPage data-id="element-14" />} data-id="element-13" />
        <Route path="/blog" element={<BlogPage data-id="element-16" />} data-id="element-15" />
        <Route path="/blog/:slug" element={<BlogArticleDetail data-id="element-18" />} data-id="element-17" />
        <Route path="/contact" element={<ContactPage data-id="element-20" />} data-id="element-19" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-22" />} data-id="element-21" />
        <Route path="/terms" element={<TermsPage data-id="element-24" />} data-id="element-23" />
        <Route path="/login" element={<LoginPage data-id="element-26" />} data-id="element-25" />
      </Routes>
    </BrowserRouter>;
}